import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {
    fetchUserNotifications,
    markUserNotificationOpen,
    resetUserNotifications
} from "../../../../creators/user.notifications";

import Notification from './Notification';
import {LoadingBar, SpinLoader} from "../../Loader";
import InfiniteScroll from "react-infinite-scroll-component";


class NotificationsList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            filter: {
                limit: this.props.isPage ? 100 : 20,
                lastId: null
            }
        };
        this.handleScroll = this.handleScroll.bind(this);

    }

    componentDidMount() {
        this.props.resetUserNotifications();

        this.fetchNotification(this.state.filter);
    }

    componentWillUnmount() {
        this.props.resetUserNotifications();
    }


    fetchNotification(query){
        let more = this.props.isPage || false;
        query = {...query};
        this.props.fetchUserNotifications(query, more);
    }

    handleScroll() {
        if(this.props.notificationCount !== 0){
            let newFilter = {...this.state.filter, lastId: this.props.notificationLastId};
            this.setState({filter: newFilter});
            this.fetchNotification(newFilter);
        }

    }

    render() {
        let notifications = [...this.props.notifications];
        return (
            <Fragment>

                <div className="notifications-list" onClick={this.props.handleCloseDropdown}>
                    {this.props.notificationLoading && <LoadingBar/>}
                    {this.props.notificationCount === 0 ? (
                        <div className="no-content">Aucune notification pour le moment</div>
                    ) :
                        this.props.isPage ? (
                                <InfiniteScroll
                                    dataLength={notifications.length} //This is important field to render the next data
                                    next={this.handleScroll}
                                    hasMore={notifications.length !== this.props.notificationCount}
                                    loader={<SpinLoader key={this.props.notificationLoading} />}
                                    /*endMessage={
                                        <span className={"no-more-content"}>
                                        Aucun contenu supplémentaire à afficher
                                    </span>
                                            }*/
                                        >
                                    {notifications.map((notification, index) => (<Notification
                                    key={index}
                                    data={notification}
                                    onOpen={() => {
                                        this.props.handleCloseDropdown();
                                        if (!notification.open) this.props.markUserNotificationOpen(notification._id);
                                    }}/>))}
                                </InfiniteScroll>
                        ) : (
                            notifications.map((notification, index) => (<Notification
                                key={index}
                                data={notification}
                                onOpen={() => {
                                    this.props.handleCloseDropdown();
                                    if (!notification.open) this.props.markUserNotificationOpen(notification._id);
                                }}/>))
                        )
                    }

                </div>
                {!this.props.isPage && (
                    <div className="see-more-notifications" onClick={this.props.handleCloseDropdown}>
                        <Link to="/notifications">Voir toutes les notifications</Link>
                    </div>)}
            </Fragment>
        )
    }

}

NotificationsList.defaultProps = {
    handleCloseDropdown: () => {
    }
};

const mapStateToProps = (state) => {
    return {
        notifications: state.userNotifications.data,
        notificationCount: state.userNotifications.total,
        notificationLoading: state.userNotifications.loading,
        notificationLastId: state.userNotifications.lastId || null,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserNotifications,
    resetUserNotifications,
    markUserNotificationOpen,
    // fetchUnreadNotifications
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
